/* ============================================================
   STRUKT — carousel.js
   Mobile-only swipe carousels for any element with [data-carousel].
   Desktop layouts are untouched (controls are hidden >= 750px and
   the layout CSS only applies below that breakpoint).
   ============================================================ */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(track) {
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;

    var controls = document.createElement('div');
    controls.className = 'carousel-controls';
    controls.innerHTML =
      '<div class="carousel-dots" role="tablist"></div>' +
      '<div class="carousel-arrows">' +
      '<button type="button" class="carousel-arrow" data-dir="-1" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 5 8 12 15 19"/></svg></button>' +
      '<button type="button" class="carousel-arrow" data-dir="1" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 5 16 12 9 19"/></svg></button>' +
      '</div>';
    track.insertAdjacentElement('afterend', controls);

    var dotsWrap = controls.querySelector('.carousel-dots');
    var prev = controls.querySelector('[data-dir="-1"]');
    var next = controls.querySelector('[data-dir="1"]');
    var dots = items.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'carousel-dot';
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(d);
      return d;
    });

    var current = 0;
    var raf = null;

    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }

    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      track.scrollTo({ left: items[i].offsetLeft - pad(), behavior: reduce ? 'auto' : 'smooth' });
    }

    function update() {
      raf = null;
      var overflows = track.scrollWidth > track.clientWidth + 8;
      var atEnd = overflows && track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var best = 0, bestDist = Infinity;
      items.forEach(function (el, i) {
        var dist = Math.abs(el.offsetLeft - pad() - track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      current = atEnd ? items.length - 1 : best;
      items.forEach(function (el, i) { el.classList.toggle('is-current', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      prev.disabled = current === 0;
      next.disabled = current === items.length - 1;
    }

    track.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(update);
    }, { passive: true });
    prev.addEventListener('click', function () { go(current - 1); });
    next.addEventListener('click', function () { go(current + 1); });

    items.forEach(function (el) { el.classList.add('is-inview'); });
    update();
    /* Layout (fonts, lazy images, reveal) can settle after init: re-sync. */
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { if (!raf) raf = requestAnimationFrame(update); });
      ro.observe(track);
      items.forEach(function (el) { ro.observe(el); });
    }
    setTimeout(update, 400);
    setTimeout(update, 1500);
  }

  function init() {
    if (!mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]:not([data-carousel-ready])'), function (track) {
      track.setAttribute('data-carousel-ready', '');
      build(track);
    });
  }

  init();
  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      /* Crossing into mobile: build. Crossing out: controls hide via CSS. */
      init();
    });
  }
})();
